module.exports = __webpack_public_path__ + "static/media/credit-cards.01d8ce3e.svg";